import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

const normalize = (str) => str?.toLowerCase().replace(/\s+/g, "") || "";

const TAB_TYPES = {
  NOMINALS: "nominals",
  ACCOUNTS: "Accounts",
  PURCHASE: "purchase",
  CONSULTANT: "consultant",
  FEEEARNER: "feeearner",
  ADMIN: "admin",
  REPORTS: "reports",
};

const getTabKey = (type) => {
  const map = {
    [TAB_TYPES.NOMINALS]: "nominalTabs",
    [TAB_TYPES.ACCOUNTS]: "accountTabs",
    [TAB_TYPES.PURCHASE]: "purchaseTabs",
    [TAB_TYPES.CONSULTANT]: "consultantTabs",
    [TAB_TYPES.FEEEARNER]: "feeearnerTabs",
    [TAB_TYPES.ADMIN]: "adminTabs",
    [TAB_TYPES.REPORTS]: "reportTabs",
  };
  return map[type] || null;
};

const initialState = {
  nominalTabs: [],
  accountTabs: [],
  purchaseTabs: [],
  consultantTabs: [],
  feeearnerTabs: [],
  adminTabs: [],
  reportTabs: [],
};

const tabsSlice = createSlice({
  name: "tabsData",
  initialState,
  reducers: {
    addTab: (state, action) => {
      const { type, data } = action.payload;
      const tabKey = getTabKey(type);
      if (!tabKey) return;

      const normalized = normalize(data);
      const arr = state[tabKey];

      if (!arr.some((item) => normalize(item) === normalized)) {
        arr.push(data);
      }
    },

    removeTab: (state, action) => {
      const { type, data } = action.payload;
      const tabKey = getTabKey(type);
      if (!tabKey) return;

      const normalized = normalize(data);
      state[tabKey] = state[tabKey].filter((item) => normalize(item) !== normalized);
    },
  },
});

const { addTab: addTabAction, removeTab: removeTabAction } = tabsSlice.actions;

const tabsReducer = tabsSlice.reducer;
const addTab = (type, data) => addTabAction({ type, data });
const removeTab = (type, data) => removeTabAction({ type, data });

const useTabs = (tabType) => {
  const tabKey = getTabKey(tabType);
  return useSelector((state) => (tabKey ? state.tabsData[tabKey] : []));
};

export {
  TAB_TYPES,
  tabsReducer,
  addTab,
  removeTab,
  useTabs,
};
